import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { GetWidgetsResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { setWidgets } from "../../store/slices/widgets";
import { IAppState } from "../../store/types/store";
import { QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { widgetKeys } from "../queryKeys";

const getWidgets = async () => {
  const resp = await api.get<GetWidgetsResponseBodyType>(`/v2/widgets`);
  return resp.data;
};

export const useGetWidgets = (
  options?: QueryOptions<GetWidgetsResponseBodyType, Error>
) => {
  return useQuery<GetWidgetsResponseBodyType, Error>({
    ...options,
    queryKey: widgetKeys.all,
    queryFn: async () => getWidgets(),
  });
};

export const useAndSetWidgets = () => {
  const dispatch = useDispatch();
  const widgetsState = useSelector((state: IAppState) => state.widgets);

  const widgetsQuery = useGetWidgets();

  useEffect(() => {
    if (widgetsQuery.isSuccess) {
      dispatch(setWidgets(widgetsQuery.data.widgets ?? []));
    }
  }, [widgetsQuery.isSuccess]);

  return widgetsState;
};
